import { createApi } from '@reduxjs/toolkit/query/react';

import {
  LoyaltyEndpoints as Endpoints,
  type ApplyReturnAsyncRequest,
  type ApplyReturnAsyncResponse,
  type GetRecordInfoAsyncRequest,
  type GetRecordInfoAsyncResponse,
  type PayWithBonusesRequest,
  type PayWithBonusesResponse,
} from '@app/api/Loyalty/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { LOYALTY_RESOURCE } from '@app/constants';

export const loyaltyApi = createApi({
  reducerPath: 'loyaltyApi',
  baseQuery: createApiBaseQuery(LOYALTY_RESOURCE),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.GetRecordInfoAsync]: query<
      GetRecordInfoAsyncResponse,
      GetRecordInfoAsyncRequest
    >({
      query: (params) => ({
        url: Endpoints.GetRecordInfoAsync,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.PayWithBonuses]: mutation<
      PayWithBonusesResponse,
      PayWithBonusesRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.PayWithBonuses,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.ApplyReturnAsync]: mutation<
      ApplyReturnAsyncResponse,
      ApplyReturnAsyncRequest
    >({
      query: (params) => ({
        url: Endpoints.ApplyReturnAsync,
        method: Methods.POST,
        params,
      }),
    }),
  }),
});

export const {
  useGetRecordInfoAsyncQuery,
  useLazyGetRecordInfoAsyncQuery,
  usePayWithBonusesMutation,
  useApplyReturnAsyncMutation,
} = loyaltyApi;
